import '../css/tailwind.css'

import { createIcons, SquareArrowOutUpRight, ChevronRight } from 'lucide';


import { createApp } from 'vue'

import Navigation from './partials/Navigation.vue'
import Calendar from './components/calendar/Calendar.vue'
import CourseList from "./components/course/CourseList.vue";
import ClassList from "./components/classlist/ClassList.vue";
import PromotedCategories from "./components/calendar/PromotedCategories.vue";
import '../../../../lib/contactform'

import { createPinia } from "pinia";

const app = createApp({});
const pinia = createPinia();

app.config.globalProperties.$t = window.$t;
app.component('navigation', Navigation)
app.component('calendar', Calendar)
app.component('courselist', CourseList)
app.component('classlist', ClassList)
app.component('promotedcategories', PromotedCategories)
app.use(pinia)

app.mount('#app')

document.addEventListener('DOMContentLoaded', () => {
    createIcons({
        icons: { SquareArrowOutUpRight, ChevronRight }
    });
    initContactForm()
}, { once: true });

/**
 * Classlist filter - only initialize if elements exist
 */
document.addEventListener('DOMContentLoaded', function() {
    const classButtons = document.querySelectorAll('.price-class-button');
    
    // Early exit if no class filter elements exist on the page
    if (!classButtons.length) return;
    
    const productLists = document.querySelectorAll('.price-product-list');
    let courseListFilterButtons = document.querySelectorAll('.course-list-filter-button');

    classButtons.forEach(button => {
        button.addEventListener('click', function() {
            const classId = this.dataset.classId;

            // Update active button
            classButtons.forEach(btn => {
                if (btn.dataset.classId === classId) {
                    btn.classList.add('bg-primary', 'border-primary', 'text-white');
                    btn.classList.remove('border-slate-300', 'bg-white', 'hover:outline-1', 'outline-primary');
                } else {
                    btn.classList.remove('bg-primary', 'border-primary', 'text-white');
                    btn.classList.add('border-slate-300', 'bg-white', 'hover:outline-1', 'outline-primary');
                }
            });

            // Show corresponding product list
            productLists.forEach(list => {
                if (list.dataset.classId === classId) {
                    list.style.display = 'block';
                } else {
                    list.style.display = 'none';
                }
            });

            if (!courseListFilterButtons.length) {
                courseListFilterButtons = document.querySelectorAll('.course-list-filter-button');
            }

            courseListFilterButtons.forEach(btn => {
                if (btn.dataset.filtervalue === classId) {
                    btn.click();
                }
            })
        });
    });
});